import React, { createContext, useContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import { getCookie } from "../utilities/cookies";
import { env } from "../utilities/function";
import axios from "axios";

const authorizeContext = createContext();

const authServer = axios.create({
  baseURL: env("AUTHENTICATION_SERVER"),
  withCredentials: true,
});

authServer.interceptors.request.use((config) => {
  const accessToken = getCookie("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

const AuthorizationProvider = ({ children }) => {
  const [content, setContent] = useState(
    <Loading message="Initializing session..." />
  );
  const [user, setUser] = useState(null);

  const authorize = async (loggedIn, cb) => {
    if (loggedIn) {
      setContent(children);
    } else {
      const cleanURL = new URL(window.location.href);
      cleanURL.searchParams.delete("userId");
      cleanURL.searchParams.delete("refreshToken");

      const redirectTo = `${env(
        "AUTHENTICATION_CLIENT"
      )}/login?redirectto=${encodeURIComponent(cleanURL.toString())}`;

      setContent(
        <Loading
          message="Redirecting to authentication service"
          redirectTo={redirectTo}
        />
      );
    }
    if (typeof cb === "function") cb(setUser);
  };

  useEffect(() => {
    (async () => {
      try {
        const queryParameters = new URLSearchParams(window.location.search);
        const userId = queryParameters.get("userId");
        const refreshToken = queryParameters.get("refreshToken");

        if (refreshToken) {
          localStorage.setItem("refreshToken", refreshToken);
          console.log("Refresh token stored in localStorage");
        }

        if (userId) {
          const response = await fetch(
            "https://accounts.clikkle.com:5000/api/auth/get_user_profile",
            {
              method: "POST",
              body: JSON.stringify({
                id: userId,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.ok) {
            const responseData = await response.json();

            localStorage.setItem("user", JSON.stringify(responseData.user));

            if (responseData.token) {
              localStorage.setItem("token", responseData.token);
              console.log("Token stored in localStorage");
            }

            document.cookie = `user=${JSON.stringify(
              responseData
            )}; path=/; max-age=${60 * 60 * 24}`;
            console.log("Cookie set with auth data");

            const { user } = responseData;
            authorize(true, (setUser) => setUser(user));
          } else {
            console.log("user not found");
          }
        } else if (localStorage.getItem("user")) {
          let user = JSON.parse(localStorage.getItem("user"));
          authorize(true, (setUser) => setUser(user));
        } else {
          authorize(false);
        }
      } catch (err) {
        console.log(err);
        authorize(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <authorizeContext.Provider value={{ authorize, setUser, user, setContent }}>
      {content}
    </authorizeContext.Provider>
  );
};

const useAuthorize = () => useContext(authorizeContext).authorize;
const useUser = () => useContext(authorizeContext)?.user;
const useSetUser = () => useContext(authorizeContext).setUser;
const useSetContent = () => useContext(authorizeContext).setContent;

export default AuthorizationProvider;
export { useAuthorize, useUser, useSetUser, useSetContent };
